import { render, staticRenderFns } from "./Add_skip_question.vue?vue&type=template&id=3f08dc8a"
import script from "./Add_skip_question.vue?vue&type=script&lang=js"
export * from "./Add_skip_question.vue?vue&type=script&lang=js"
import style0 from "./Add_skip_question.vue?vue&type=style&index=0&id=3f08dc8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports